module.exports = __webpack_public_path__ + "img/house6b.8f938ce0.jpg";